@use '@/styles/tokens' as *;

.banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-4);
  border-radius: 15px;
}

.lime {
  background: $color-accent2-100;
}

.muted {
  background: $color-light-brown-100;
}

.icon {
  flex: 0 0 auto;
  display: inline-flex;
  color: $color-brand-600;
}

/* Offer Expired uses a neutral warning icon, not the brand-green success tint. */
.muted .icon {
  color: $color-neutral-600;
}

.text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.title {
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  color: $color-neutral-950;
}

.desc {
  margin: 0;
  font-size: 11px;
  color: $color-neutral-700;
}
